<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="600px"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        color="success"
        block
        v-on="on"
      >
        Create EPF Setting
      </v-btn>
    </template>
    <material-card
      :offset="10"
      :full-width="true"
      color="success"
      title="Employees' Provident Fund"
      text="Create EPF Settings"
      class="mb-0"
    > 
      <form v-if="dialog">
        <v-container>
          <v-row no-gutters>
            <v-col cols="12">
              <v-autocomplete
                v-model="category"
                v-validate="'required'"
                :error-messages="errors.collect('category')"
                :items="categories"
                data-vv-name="key"
                data-vv-as="category"
                item-text="name"
                item-value="key"
                label="EPF Category / Part"
              />
            </v-col>

            <v-col cols="12">
              <v-text-field
                v-model="total_gross_without_additional_remuneration"
                v-validate="'required|twoDecimalValue'" 
                type="number"
                :error-messages="errors.collect('total_gross_without_additional_remuneration')"
                data-vv-name="total_gross_without_additional_remuneration"                
                data-vv-as="gross"      
                prefix="RM"          
                label="Gross"
              />
            </v-col>

            <v-col cols="12">
              <v-text-field
                v-model="total_gross_with_additional_remuneration"
                v-validate="'required|twoDecimalValue'" 
                type="number"
                :error-messages="errors.collect('v')"
                data-vv-name="total_gross_with_additional_remuneration"                
                data-vv-as="gross + additional remuneration"  
                prefix="RM"          
                label="Gross + Additional Remuneration"
              />
            </v-col>

            <v-col cols="12">
              <v-text-field
                v-model="employee_rate"
                v-validate="'required|twoDecimalValue'" 
                type="number"
                :error-messages="errors.collect('employee_rate')"
                data-vv-name="employee_rate"                
                data-vv-as="employee rate"                
                label="Employee Rate"
                prefix="RM"
              />
            </v-col>

            <v-col cols="12">
              <v-text-field
                v-model="employer_rate"
                v-validate="'required|twoDecimalValue'" 
                type="number"
                :error-messages="errors.collect('employer_rate')"
                data-vv-name="employer_rate"                
                data-vv-as="employer rate"                
                label="Employer Rate"
                prefix="RM"
              />
            </v-col>

            <v-col cols="12">
              <v-textarea
                v-model="description"
                v-validate="'max:1000'"
                :rows="3"
                :error-messages="errors.collect('description')"
                data-vv-name="description"     
                data-vv-as="description"           
                label="Description"
              />
            </v-col>
          </v-row>
        </v-container>
      </form>
      
      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="success"          
          @click="submitForm"
        >
          Create
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  import Big from 'big.js'
  export default {
    inject: ['$validator'],
    data () {
      return {
        categories: [
          { key: 'A', name: 'A' },
          { key: 'E', name: 'E' },
        ],
        progressing: false,
        dialog: null,
        total_gross_without_additional_remuneration: null,
        total_gross_with_additional_remuneration: null,
        employee_rate: null,
        employer_rate: null,
        description: null,
        category: null,
      }
    },
    watch: {
      dialog: function (value) {
        if (!value) return       
        this.resetForm()
      },
      total_gross_without_additional_remuneration (newVal) {
        if (newVal === '' || newVal === 0) {
          this.total_gross_without_additional_remuneration = null
        }
      },
    },

    mounted () {
      let _this = this

      this.$validator.extend('twoDecimalValue', {
        getMessage (field, args) {
          return 'Only 2 Decimals are allowed'
        },
        validate (value, args) {
          return _this.isValidNumbers(value)
        },
      })
    },

    methods: { 
      prepareFormData () {
        return {
          total_gross_without_additional_remuneration: this.total_gross_without_additional_remuneration ? this.total_gross_without_additional_remuneration * 100 : null,
          total_gross_with_additional_remuneration: this.total_gross_with_additional_remuneration ? this.total_gross_with_additional_remuneration * 100 : null,
          employee_rate: this.employee_rate,
          employer_rate: this.employer_rate,
          description: this.description,
          category: this.category,
        }
      },   
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return 

            this.setProgressing(true)
            
            this.$api.epfSettings().create(this.prepareFormData())
              .then((res) => {
                if (res.status === 201) {
                  this.$emit('created', res.data)                
                  this.$snack({ message: 'Added new EPF Settings' })

                  this.setDialog(false)                
                }
              })
              .catch(() => {})
              .then(() => {
                this.setProgressing(false)
              })
          })
      },
      setProgressing (status) {
        this.progressing = status
      },
      setDialog (status) {
        this.dialog = status
      },
      resetForm () {
        this.$validator.reset()
        this.total_gross_without_additional_remuneration = null
        this.total_gross_with_additional_remuneration = null
        this.employee_rate = null
        this.employer_rate = null
        this.description = null
        this.category = null
      },

      isValidNumbers (value) {
        return (new Big(value).times(10000) % 100 === 0)
      },
    },
  }
</script>
